import { api } from "../../lib";

export interface InsuranceProvider {
  id: string;
  name: string;
  naicNumber: string | null;
  mailingAddress: string | null;
  city: string | null;
  state: string | null;
  zipCode: string | null;
  phoneNumber: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateInsuranceProviderInput {
  name: string;
  naicNumber?: string;
  mailingAddress?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  phoneNumber?: string;
  isActive?: boolean;
}

export interface UpdateInsuranceProviderInput
  extends Partial<CreateInsuranceProviderInput> {
  id: string;
}

export const insuranceProvidersService = {
  getAll: async () => {
    return api.get<InsuranceProvider[]>("/admin/insurance-providers");
  },

  getById: async (id: string) => {
    return api.get<InsuranceProvider>(`/admin/insurance-providers/${id}`);
  },

  create: async (input: CreateInsuranceProviderInput) => {
    return api.post<InsuranceProvider>("/admin/insurance-providers", input);
  },

  update: async (input: UpdateInsuranceProviderInput) => {
    const { id, ...updates } = input;
    return api.put<InsuranceProvider>(
      `/admin/insurance-providers/${id}`,
      updates
    );
  },

  toggleActive: async (id: string, isActive: boolean) => {
    return api.put<InsuranceProvider>(`/admin/insurance-providers/${id}`, {
      isActive: !isActive,
    });
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/insurance-providers/${id}`);
  },
};
